const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,

  au: state => state.user.userInfo.au,
  userId: state => state.user.userInfo.userId,
  userName: state => state.user.userInfo.userName,
  loginName: state => state.user.userInfo.loginName,
  authMap: state => state.user.userInfo.authMap,
  userTypeList: state => state.user.userTypeList
}
export default getters
